import Tippy from "@tippyjs/react";
import type { TippyProps } from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import "./theme.css";

// Custom Vodafone Theme for Tippy
export const Tooltip = (props: TippyProps): JSX.Element => (
  <Tippy
    allowHTML={true}
    arrow={false}
    theme="vf"
    content={props.content}
    placement={props.placement}
    interactive={props.interactive}
    delay={props.delay}
    disabled={props.disabled}
  >
    {props.children}
  </Tippy>
);
